import { ColumnDef } from '@tanstack/react-table';
import DataTableRowActions from "@/components/data-table/data-table-row-actions.tsx";
import {DataTableColumnHeader} from "@/components/data-table/data-table-column-header.tsx";
import {User} from "@/types/User.ts";
import {UserRole} from "@/types/UserRole.ts";
import {Badge} from "@/components/ui/badge.tsx";

interface UsersColumnsProps {
    onEdit: (user: User) => void;
    onDelete: (user: User) => void;
}

export const getUsersColumns = ({ onEdit, onDelete }: UsersColumnsProps): ColumnDef<User>[] => [
    {
        id: "firstName",
        accessorKey: "firstName",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="firstName" />
        ),
    },
    {
        id: "lastName",
        accessorKey: "lastName",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="lastName" />
        ),
    },
    {
        id: "email",
        accessorKey: "email",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="email" />
        ),
        enableHiding: false,
    },
    {
        id: "role",
        accessorKey: "role",
        header: ({ column }) => (
            <DataTableColumnHeader column={column} title="role" />
        ),
        cell: ({ row }) => {
            const role = Object.values(UserRole).find(
                (role) => role === row.getValue("role")
            );

            if (!role) {
                return null;
            }

            return (
                <div className="flex items-center capitalize">
                    <Badge variant={role === UserRole.ADMIN ? 'destructive' : role === UserRole.MENTOR ? 'secondary' : 'default'}>
                        {role}
                    </Badge>
                </div>
            );
        },
        filterFn: (row, id, value) => {
            return value.includes(row.getValue(id));
        },
        enableHiding: false,
    },
    {
        id: 'actions',
        cell: ({ row }) => {
            const user = row.original;
            let viewProfileUrl: string;
            if (user.role === UserRole.MENTOR && user.mentor?.id != null) {
                viewProfileUrl = `/mentors/${user.mentor.id}`;
            } else if (user.role === UserRole.MENTEE && user.mentee?.id != null) {
                viewProfileUrl = `/mentees/${user.mentee.id}`;
            } else {
                viewProfileUrl = `/users/${user.id}`;
            }
            return <DataTableRowActions row={row} onEdit={onEdit} onDelete={onDelete} viewProfileUrl={viewProfileUrl} />;
        },
    },
]
